/**
 * Every string the walkthrough ENGINE says on its own (not from a tour step):
 * notes, the completion card, the blocked-navigation note, toasts, and the
 * invite / welcome card chrome. One place, so the disclosure suite renders all
 * of it for every access profile (they must stay generic — no capability names,
 * no write instructions).
 */
export const ENGINE_COPY = {
  centred: {
    hidden: "This isn't visible at this screen size.",
    blocked:
      "This is in another view. The tour won't switch away from the tab you're on, in case you have work in progress there.",
  },
  missingPrefix: "This isn't showing on the page right now.",
  blockedTitle: 'This step opens another page',
  blockedBody: (stepTitle: string) =>
    `"${stepTitle}" is on another page, and the tour never leaves a page where you might have unsaved work. Press Next to continue here, or go there yourself and start the tour again.`,
  complete: {
    title: 'Tour complete',
    body: "That's everything this tour can show right now. Press Finish to close it.",
  },
  loading: { title: 'One moment…', body: 'Waiting for this part of the page to load.' },
  toast: {
    unavailableTitle: 'Tour not available',
    unavailableRest: "The rest of this tour isn't available right now.",
    unavailableNothing: "There's nothing this tour can show on this page right now.",
    pageLoadingTitle: 'Page still loading',
    pageLoading: 'This page is still loading. Try the guide again in a moment.',
    pageForbidden: "This page isn't available for your role, so there's nothing to show here.",
    pageDown: "This page isn't available right now, so there's nothing to show here.",
    accessLostTitle: 'Tour ended',
    accessLost: 'The tour ended because your access changed.',
    dialogOpenTitle: 'Close the open dialog first',
    dialogOpen: 'Then start the tour again.',
    laterTitle: 'Maybe later',
    inviteLater: 'You can open the guide any time from the ? button.',
    welcomeLater: 'You can start the tour any time from the ? button.',
    welcomeLaterNarrow: 'On a wider screen, the ? button in the header starts the tour any time.',
    optOutTitle: 'Page tours off',
    optOut: 'Guides are still in the ? menu on every page.',
  },
  invite: {
    title: (tourTitle: string) => `New to "${tourTitle}"?`,
    body: (steps: number) => `Take a quick tour of this page: ${steps} steps.`,
  },
} as const

/** Flat list of every fixed engine string (for the disclosure suite). */
export function allEngineStrings(): string[] {
  const out: string[] = []
  const walk = (v: unknown) => {
    if (typeof v === 'string') out.push(v)
    else if (typeof v === 'function') out.push(String((v as (x: string) => string)('')))
    else if (v && typeof v === 'object') Object.values(v).forEach(walk)
  }
  walk(ENGINE_COPY)
  return out
}
